const Container = ({ children }: { children: React.ReactNode }) => (
  <div className="flex h-full w-full items-center justify-center">
    {children}
  </div>
);

export default Container;
